import YFormIcon from './Icon';

export { YFormIcon };
export default YFormIcon;
